import { render, staticRenderFns } from "./updateprofile.vue?vue&type=template&id=c03ae3be&scoped=true&"
import script from "./updateprofile.vue?vue&type=script&lang=js&"
export * from "./updateprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03ae3be",
  null
  
)

export default component.exports